const BlockStates = {
  IDLE: "Run",
  WAITING: "Waiting",
  RUNNING: "Running",
  SUCCESS: "Done",
  ERROR: "Error",
};

export default BlockStates;
